<template>
  <div>
    <div
      v-if="data.adminPanel"
      class="pb-3 text-left"
    >
      <v-btn
        class=""
        dark
        small
        left
        title="بازگشت"
        @click="$emit('back')"
      >
        بازگشت
        <v-icon dark>
          mdi-chevron-left
        </v-icon>
      </v-btn>
    </div>

    <v-alert
      v-if="data.userloan != null"
      icon="mdi-shield-lock-outline"
      prominent
      text
      type="info"
    >
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          {{ data.userloan.loanModel.title }}
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          {{ data.userloan.amount.toString().toPriceFormat() }} ریال
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          شروع: {{ data.userloan.startDate_Persian.date }}
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          هر قسط: {{ data.userloan.installment.toString().toPriceFormat() }} ریال
        </v-col>
      </v-row>
    </v-alert>

    <div>
      <div class="text-h4 mb-3 text-center">
        لیست اقساط پرداخت شده
      </div>
    </div>

    <div>
      <v-data-table
        :headers="headers"
        :items="installments"
        :items-per-page="500"
        class="elevation-1"
      >
        <template v-slot:item="row">
          <tr>
            <td class="text-center">
              {{ row.item.amount.toString().toPriceFormat() }} ریال
            </td>
            <td class="text-center">
              {{ row.item.saveDate_Persian.date }}
            </td>
            <td class="text-center">
              {{ `${row.item.targetMonth_Persian.year}/${row.item.targetMonth_Persian.month}` }}
            </td>
            <td
              v-if="data.adminPanel"
              class="text-center"
            >
              {{ row.item.savedBy }}
            </td>

            <td
              v-if="data.adminPanel"
              class="text-center"
            >
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="secondary"
                @click="edit(row.item)"
              >
                <v-icon dark>
                  mdi-square-edit-outline
                </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="pink"
                @click="remove(row.item)"
              >
                <v-icon dark>
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-dialog
      v-model="dialogModifyLoanPayment"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <div><span class="headline">ویرایش قسط</span></div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <modify-loan-payment
              ref="modifyLoanPayment"
              :data="selectedLoanPayment"
              @callbck="callbck_loanPayment"
            />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <confirm-dlg ref="confirm" />
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import ModifyLoanPayment from './ModifyLoanPayment.vue'

  export default {
    name: 'LoanInstallmentsView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'modify-loan-payment': ModifyLoanPayment,
    },
    props: {
      data: { type: Object },
    },
    data () {
      return {
        errorMessages: '',
        dialogModifyLoanPayment: false,
        selectedLoanPayment: null,
        installments: [],
        headers: [],
      }
    },
    mounted () {
      this.headers = [{
        text: 'مبلغ',
        align: 'center',
        sortable: true,
        value: 'amount',
      }, {
        text: 'تاریخ ثبت',
        align: 'center',
        sortable: true,
        value: 'saveDate_Persian',
      }, {
        text: 'مربوط به',
        align: 'center',
        sortable: true,
        value: 'targetMonth',
      }]
      if (this.data.adminPanel) {
        this.headers.push({
          text: 'ثبت توسط',
          align: 'center',
          sortable: true,
          value: 'savedBy',
        })
        this.headers.push({
          text: 'عملیات ها',
          align: 'center',
          sortable: false,
          width: 200,
        })
      }
    },
    methods: {
      edit (userLoan) {
        this.dialogModifyLoanPayment = true
        this.selectedLoanPayment = { id: userLoan.id }
        this.$nextTick(() => {
          this.$refs.modifyLoanPayment.prepareData()
        })
      },
      async remove (item) {
        if (!item) { return }

        if (await this.$refs.confirm.open(
          'توجه',
          'آیا از حذف این آیتم مطمئن هستید؟',
        )) {
          api.post('admin/loanpayment/delete/' + item.id)
            .then(
              response => {
                toast.success('اطلاعات با موفقیت حذف شد.')
                this.loadData()
              })
            .catch(err => {
              toast.error(err.message)
            })
        }
      },
      loadData () {
        api.get('admin/loanpayment/getLoanPayments/' + this.data.userloan.id, null)
          .then(
            response => {
              this.installments = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      callbck_loanPayment (result) {
        this.dialogModifyLoanPayment = false
        if (result) { this.loadData() }
      },
    },
  }
</script>
<style>

</style>
